import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// image helper: convert a search phrase into a reliable topical image url
export function imgUrl(query, w = 1200, h = 800) {
  if (!query) query = "abstract";
  if (typeof query === "string" && query.startsWith("http")) return query;
  const q = encodeURIComponent(String(query).trim().replace(/\s+/g, ","));
  return `https://loremflickr.com/${w}/${h}/${q}`;
}

export function fallbackImg(query, w = 1200, h = 800) {
  const seed = encodeURIComponent(String(query || "site"));
  return `https://picsum.photos/seed/${seed}/${w}/${h}`;
}

export function absoluteUrl(path) {
  if (!path) return path;
  if (typeof path === "string" && path.startsWith("http")) return path;
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
}

export async function uploadImage(projectId, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/projects/${projectId}/upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return { fileId: data.file_id, url: absoluteUrl(data.url), filename: data.filename };
}

export default api;
